import { Layout } from 'antd';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import images from 'constants/images';
import { PublishHeader, DraftHeader, HistoryHeader } from './components';
import { useProposalContext } from 'context/proposal';

import './ProposalHeaderBar.scss';

const { Header } = Layout;

const ProposalHeaderBar = ({
  mode,
  isPublishing,
  publishProposal,
  restoreProposal,
  openHistory,
  openPublishView,
  copyPropsalLink,
  publishedProposalLink,
  user,
  isTemplate,
  isSection,
  updateScreen,
  screen,
  handleManualSave,
  disablePreview,
  configText,
  path,
  setKeyboardModal,
  buttons,
  setProposalPublished,
  setCollapseContentTable,
  setCollapseSidemenu,
  backupPreviewId,
  backupPreviewLoading,
  restoring,
  proposal: proposalProp,
}) => {
  const context = useProposalContext();
  const proposal = context?.proposal ?? proposalProp;
  const published = proposal ? !!proposal.published : false;

  return (
    <Header className="proposal-header">
      <NavLink
        to={isTemplate || isSection ? `/contentlibrary?tab=${isSection ? '4' : '1'}` : '/'}
        className="prospero-logo">
        <img src={images.LOGO_SMALL} alt="proposal-logo-small" />
      </NavLink>

      {mode === 'wizard' && (
        <div className="main-wrapper wizard">
          <div className="block block-1">{buttons}</div>
        </div>
      )}

      {mode === 'draft' && (
        <DraftHeader
          openPublishView={openPublishView}
          user={user}
          isSection={isSection}
          handleManualSave={handleManualSave}
          disablePreview={disablePreview}
          configText={configText}
          path={path}
          setKeyboardModal={setKeyboardModal}
          setCollapseContentTable={setCollapseContentTable}
          setCollapseSidemenu={setCollapseSidemenu}
          openHistory={openHistory}
        />
      )}

      {mode === 'history' && proposal && (
        <HistoryHeader
          backupPreviewId={backupPreviewId}
          backupPreviewLoading={backupPreviewLoading}
          restoreProposal={restoreProposal}
          restoring={restoring}
          approved={proposal.state === 'approved'}
        />
      )}

      {mode === 'publish' && proposal && (
        <PublishHeader
          published={published}
          isPublishing={isPublishing}
          proposal={proposal}
          publishProposal={publishProposal}
          copyPropsalLink={copyPropsalLink}
          publishedProposalLink={publishedProposalLink}
          isTemplate={isTemplate}
          isSection={isSection}
          updateScreen={updateScreen}
          screen={screen}
          setProposalPublished={setProposalPublished}
        />
      )}
    </Header>
  );
};

ProposalHeaderBar.defaultProps = {
  mode: 'wizard',
  isPublishing: false,
  publishProposal: () => {},
  restoreProposal: () => {},
  openHistory: () => {},
  openPublishView: () => {},
  copyPropsalLink: () => {},
  publishedProposalLink: () => {},
  user: '',
  isTemplate: false,
  isSection: false,
  updateScreen: () => {},
  screen: '',
  handleManualSave: () => {},
  disablePreview: false,
  configText: () => {},
  path: '',
  setKeyboardModal: () => {},
  buttons: null,
  setProposalPublished: () => {},
  setCollapseContentTable: () => {},
  setCollapseSidemenu: () => {},
  backupPreviewId: null,
  backupPreviewLoading: false,
  restoring: false,
  proposal: undefined,
};

ProposalHeaderBar.propTypes = {
  mode: PropTypes.oneOf(['wizard', 'draft', 'publish', 'history']),
  isPublishing: PropTypes.bool,
  publishProposal: PropTypes.func,
  restoreProposal: PropTypes.func,
  openHistory: PropTypes.func,
  openPublishView: PropTypes.func,
  copyPropsalLink: PropTypes.func,
  publishedProposalLink: PropTypes.func,
  user: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  isTemplate: PropTypes.bool,
  isSection: PropTypes.bool,
  updateScreen: PropTypes.func,
  screen: PropTypes.string,
  handleManualSave: PropTypes.func,
  disablePreview: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  configText: PropTypes.func,
  path: PropTypes.string,
  setKeyboardModal: PropTypes.func,
  buttons: PropTypes.node,
  setProposalPublished: PropTypes.func,
  setCollapseContentTable: PropTypes.func,
  setCollapseSidemenu: PropTypes.func,
  backupPreviewId: PropTypes.string,
  backupPreviewLoading: PropTypes.bool,
  restoring: PropTypes.bool,
  proposal: PropTypes.object,
};
export default ProposalHeaderBar;
